module.exports = __webpack_public_path__ + "media/images/icons/icon-new-banner-tail-745ab181ed9a771e3c36537f472002bb.svg";